import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { ReliabilityNoticeLine } from './ReliabilityNoticeLine';
import { ReliabilityNoticeLink } from './ReliabilityNoticeLink';
import { TransphereUnsentStepsModal } from './TransphereUnsentStepsModal';

interface TransphereUnsentInvoicesIndicatorProps {
    count: number;
    /** Opens Acomba GO's pending-send window; omitted when there is no portal host. */
    onOpen?: () => void;
}

// The invoice never reached the customer, so no reminder is due and the list below is quietly incomplete.
export const TransphereUnsentInvoicesIndicator: React.FC<TransphereUnsentInvoicesIndicatorProps> = ({
    count,
    onOpen,
}) => {
    const [stepsOpen, setStepsOpen] = useState(false);

    return (
        <>
            <ReliabilityNoticeLine testId="transphere-unsent-indicator">
                {/* Trans, not t: the linked words sit mid-sentence and French agrees the noun with the count,
                    so each plural form is its own string. Without a portal window to open, the link shows the
                    steps to follow in Acomba instead. */}
                <Trans
                    i18nKey={TranslationKey.Home.TransphereUnsentIndicator.Message}
                    count={count}
                    values={{ count }}
                    components={{
                        action: (
                            <ReliabilityNoticeLink
                                onClick={onOpen ?? (() => setStepsOpen(true))}
                                testId="transphere-unsent-indicator-open-btn"
                            />
                        ),
                    }}
                />
            </ReliabilityNoticeLine>
            {stepsOpen && <TransphereUnsentStepsModal count={count} onClose={() => setStepsOpen(false)} />}
        </>
    );
};
